import { useEffect, useRef } from 'react';

import { IdFile } from '../../../shared/models/id-file.model';
import { GetStringKeys } from '../../../shared/types/get-string-keys.type';

export const useSetApkDragAndDropTouched = <TFormik>(
  apkValues: IdFile[] | undefined,
  setFieldTouched: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void,
  fieldName: GetStringKeys<TFormik>
) => {
  const prevLenRef = useRef<number>(apkValues?.length ?? 0);

  useEffect(() => {
    const currLen = apkValues?.length ?? 0;
    const prevLen = prevLenRef.current;

    if (currLen !== prevLen) {
      setFieldTouched(fieldName, true, true);
      prevLenRef.current = currLen;
    }
  }, [apkValues]);
};
